import { Footer } from '@/previewThemes/pawly/Footer';
import { Header } from '@/previewThemes/pawly/Header';
import { Product } from '@/previewThemes/pawly/Product';
import { pawlyProductParts, pawlyProductSections } from '@/previewThemes/pawly/productPage';
import type { ThemePackage } from '@/previewThemes/types';

export const theme: ThemePackage = {
  Header,
  Footer,
  Product,
  // The cart opens as a drawer from the right - from the header's cart link
  // and after "Add to cart" - so a shopper stocking up on food and treats
  // never leaves the aisle.
  quickCart: true,
  listing: {
    // Three across beside the filter rail: a pet owner filters first - dog or
    // cat, food or toy - and the rounded tiles need the width three columns
    // leave them to read as big, friendly pictures.
    grid: 'grid-cols-2 gap-6 lg:grid-cols-3',
    filters: 'sidebar',
    columns: 3,
    // The picture on its own rounded oat tile, the name and price loose on the
    // cream below: the pale product photographs sit on the oat ground rather
    // than inside a second outline.
    card: 'standard',
  },
  cart: { grid: 'mt-8 grid gap-8 lg:grid-cols-3', panel: 'filled' },
  checkout: {
    grid: 'mt-8 grid items-start gap-8 lg:grid-cols-[minmax(0,1fr)_24rem] lg:gap-12',
    panel: 'filled',
  },
  search: {
    grid: 'mt-8 grid gap-8 lg:grid-cols-[240px_1fr]',
    results: 'grid grid-cols-2 gap-6 lg:grid-cols-3',
    columns: 3,
    card: 'standard',
    // The facet rail on an oat panel, so the filters read as one soft block
    // beside the results.
    panel: 'filled',
  },
  blog: { list: 'grid gap-8 sm:grid-cols-2 lg:grid-cols-3', title: 'text-2xl' },
  // The shelves four across, each a rounded picture with its name under it.
  category: { grid: 'grid gap-6 sm:grid-cols-2 lg:grid-cols-4', tile: 'card' },
  pages: {
    product: { defaults: pawlyProductSections },
  },
  parts: {
    product_details: {
      defaults: pawlyProductParts,
      presentation: {
        classes: {
          product_brand: 'text-[12px] font-semibold uppercase tracking-[0.14em]',
          product_title: 'text-4xl sm:text-5xl leading-none',
          product_price: 'text-2xl font-semibold',
          product_short_description: 'text-[15px]',
        },
        wideButtons: true,
        gallery: { aspect: 'square', thumbs: 'below' },
      },
    },
  },
};
